import { commitMutation, graphql } from 'react-relay';

import { sendError } from '../appsignal';

const mutation = graphql`
  mutation AddFotoBookToCartMutation($input: AddFotoBookToCartInput!) {
    addFotoBookToCart(input: $input) {
      cart {
        id
        lineItems {
          id
          productType
          product {
            id
            label
            price
          }
        }
        totalPrice
      }
    }
  }
`;

function commit(environment, productId, configuration, language, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        productId,
        configuration,
        language,
      },
    },
    updater: store => {
      const payload = store.getRootField('addFotoBookToCart');
      const cart = payload.getLinkedRecord('cart');
      const viewer = store.get('root');
      viewer.setLinkedRecord(cart, 'cart');
    },
    onCompleted: (response, errors) => {
      if (errors) {
        sendError(errors[0]);
        callback && callback(errors[0], null);
      } else {
        callback && callback(null, response.addFotoBookToCart.cart);
      }
    },
    onError: err => {
      sendError(err);
      callback && callback(err, null);
    },
  });
}

export default { commit };
